import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";

const config = {
  apiKey: "AIzaSyDGAyRNh2lisHbSOw9qExauMQodO6bR7DA",
  authDomain: "bampfa-715df.firebaseapp.com",
  databaseURL: "https://bampfa-715df.firebaseio.com",
  projectId: "bampfa-715df",
  storageBucket: "gs://bampfa-715df.appspot.com",
  messagingSenderId: "114997490281"
};
firebase.initializeApp(config);
export default firebase;
